import { render, staticRenderFns } from "./GameClock.vue?vue&type=template&id=579803ea&scoped=true&"
import script from "./GameClock.vue?vue&type=script&lang=js&"
export * from "./GameClock.vue?vue&type=script&lang=js&"
import style0 from "./GameClock.vue?vue&type=style&index=0&id=579803ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579803ea",
  null
  
)

export default component.exports